import React, { useEffect, useState } from "react";
import logo from "../../../assets/Images/Kapil-Logo.png";
import { Link, NavLink, useLocation, useMatches } from "react-router-dom";
import GateKeeper from "../../../rbac/GateKeeper";
const Sidebar = ({ open }) => {
  const location = useLocation();
  const matches = useMatches();
  console.log(location, "location");
  console.log(matches, "matches");
  useEffect(() => {
    let updated = matches[1].pathname.split("/");
    console.log("updated", updated);
    if (updated[1] === "") {
      setActive("Home");
    } else if (updated[1] === "users") {
      setActive("Users");
    } else if (updated[1] === "entities") {
      setActive("Entities");
    } else if (updated[1] === "teams") {
      setActive("Teams");
    } else if (updated[1] === "boardmeetings") {
      setActive("Meetings");
    } else if (updated[1] === "tasks") {
      setActive("Decisions");
    } else if (updated[1] === "reports") {
      setActive("Reports");
    } else if (updated[1] === "settings") {
      setActive("Settings");
    }
  }, [matches]);
  const menus = [
    {
      name: "Users",
      link: "/users",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          class="w-4 h-4"
        >
          <path
            fill-rule="evenodd"
            d="M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z"
            clip-rule="evenodd"
          />
        </svg>
      ),
      module: "user",
    },
    {
      name: "Entities",
      link: "/entities",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          className="w-5 h-5"
        >
          <path
            fill-rule="evenodd"
            d="M8 1a.75.75 0 0 1 .75.75V6h-1.5V1.75A.75.75 0 0 1 8 1Zm-.75 5v3.296l-.943-1.048a.75.75 0 1 0-1.114 1.004l2.25 2.5a.75.75 0 0 0 1.114 0l2.25-2.5a.75.75 0 0 0-1.114-1.004L8.75 9.296V6h2A2.25 2.25 0 0 1 13 8.25v4.5A2.25 2.25 0 0 1 10.75 15h-5.5A2.25 2.25 0 0 1 3 12.75v-4.5A2.25 2.25 0 0 1 5.25 6h2ZM7 16.75v-.25h3.75a3.75 3.75 0 0 0 3.75-3.75V10h.25A2.25 2.25 0 0 1 17 12.25v4.5A2.25 2.25 0 0 1 14.75 19h-5.5A2.25 2.25 0 0 1 7 16.75Z"
            clip-rule="evenodd"
          />
        </svg>
      ),
      module: "entity",
    },
    {
      name: "Teams",
      link: "/teams",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          className="w-5 h-5"
        >
          <path d="M10 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM6 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM1.49 15.326a.78.78 0 0 1-.358-.442 3 3 0 0 1 4.308-3.516 6.484 6.484 0 0 0-1.905 3.959c-.023.222-.014.442.025.654a4.97 4.97 0 0 1-2.07-.655ZM16.44 15.98a4.97 4.97 0 0 0 2.07-.654.78.78 0 0 0 .357-.442 3 3 0 0 0-4.308-3.517 6.484 6.484 0 0 1 1.907 3.96 2.32 2.32 0 0 1-.026.654ZM18 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM5.304 16.19a.844.844 0 0 1-.277-.71 5 5 0 0 1 9.947 0 .843.843 0 0 1-.277.71A6.975 6.975 0 0 1 10 18a6.974 6.974 0 0 1-4.696-1.81Z" />
        </svg>
      ),
      module: "team",
    },
    {
      name: "Meetings",
      link: "/boardmeetings",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          class="w-5 h-5"
        >
          <path d="M4.5 6.375a4.125 4.125 0 1 1 8.25 0 4.125 4.125 0 0 1-8.25 0ZM14.25 8.625a3.375 3.375 0 1 1 6.75 0 3.375 3.375 0 0 1-6.75 0ZM1.5 19.125a7.125 7.125 0 0 1 14.25 0v.003l-.001.119a.75.75 0 0 1-.363.63 13.067 13.067 0 0 1-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 0 1-.364-.63l-.001-.122ZM17.25 19.128l-.001.144a2.25 2.25 0 0 1-.233.96 10.088 10.088 0 0 0 5.06-1.01.75.75 0 0 0 .42-.643 4.875 4.875 0 0 0-6.957-4.611 8.586 8.586 0 0 1 1.71 5.157v.003Z" />
        </svg>
      ),
      module: "meeting",
    },
    {
      name: "Decisions",
      link: "/tasks/runningdecisions",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          className="w-5 h-5"
        >
          <path
            fill-rule="evenodd"
            d="M18 5.25a2.25 2.25 0 0 0-2.012-2.238A2.25 2.25 0 0 0 13.75 1h-1.5a2.25 2.25 0 0 0-2.238 2.012c-.875.092-1.6.686-1.884 1.488H11A2.5 2.5 0 0 1 13.5 7v7h2.25A2.25 2.25 0 0 0 18 11.75v-6.5ZM12.25 2.5a.75.75 0 0 0-.75.75v.25h3v-.25a.75.75 0 0 0-.75-.75h-1.5Z"
            clip-rule="evenodd"
          />
          <path
            fill-rule="evenodd"
            d="M3 6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H3Zm6.874 4.166a.75.75 0 1 0-1.248-.832l-2.493 3.739-.853-.853a.75.75 0 0 0-1.06 1.06l1.5 1.5a.75.75 0 0 0 1.154-.114l3-4.5Z"
            clip-rule="evenodd"
          />
        </svg>
      ),
      module: "task",
    },
    {
      name: "Reports",
      link: "/reports",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          className="w-5 h-5"
        >
          <path
            fill-rule="evenodd"
            d="M1 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V6Zm4 1.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2 3a4 4 0 0 0-3.665 2.395.75.75 0 0 0 .416 1A8.98 8.98 0 0 0 7 14.5a8.98 8.98 0 0 0 3.249-.604.75.75 0 0 0 .416-1.001A4.001 4.001 0 0 0 7 10.5Zm5-3.75a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Zm0 6.5a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Zm.75-4a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-2.5Z"
            clip-rule="evenodd"
          />
        </svg>
      ),
      module: "report",
    },
    {
      name: "Settings",
      link: "/settings",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          className="w-5 h-5"
        >
          <path
            fill-rule="evenodd"
            d="M7.84 1.804A1 1 0 0 1 8.82 1h2.36a1 1 0 0 1 .98.804l.331 1.652a6.993 6.993 0 0 1 1.929 1.115l1.598-.54a1 1 0 0 1 1.186.447l1.18 2.044a1 1 0 0 1-.205 1.251l-1.267 1.113a7.047 7.047 0 0 1 0 2.228l1.267 1.113a1 1 0 0 1 .206 1.25l-1.18 2.045a1 1 0 0 1-1.187.447l-1.598-.54a6.993 6.993 0 0 1-1.929 1.115l-.33 1.652a1 1 0 0 1-.98.804H8.82a1 1 0 0 1-.98-.804l-.331-1.652a6.993 6.993 0 0 1-1.929-1.115l-1.598.54a1 1 0 0 1-1.186-.447l-1.18-2.044a1 1 0 0 1 .205-1.251l1.267-1.114a7.05 7.05 0 0 1 0-2.227L1.821 7.773a1 1 0 0 1-.206-1.25l1.18-2.045a1 1 0 0 1 1.187-.447l1.598.54A6.992 6.992 0 0 1 7.51 3.456l.33-1.652ZM10 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
            clip-rule="evenodd"
          />
        </svg>
      ),
      module: "setting",
    },
  ];

  const [active, setActive] = useState("Home");

  return (
    <div className={`sidebar ${open ? "expand" : "close"}`}>
      <ul className="mt-4">
        <li className="px-2  ">
          <div className="sidebar-menu ">
            <span className="icon ">
              <img src={logo} alt="Infoz IT" className={`w-18 h-7  p-0 `} />
            </span>
            <span className="text">
              <span className="text-[#372f81] font-semibold text-md leading-normal ">
                &nbsp; Kapil
              </span>
              &nbsp;
              <span className="text-[#ae060d] font-semibold text-md leading-normal">
                Group
              </span>
            </span>
          </div>
        </li>
        <li className="px-2">
          <Link
            className={`sidebar-menu flex items-center text-md gap-2 font-semibold  leading-normal
                                  hover:bg-orange-600 hover:text-white rounded-md
          ${"Home" === active ? "text-orange-600" : "black"}`}
            to="/"
            onClick={(e) => {
              setActive("Home");
            }}
          >
            <span className="icon ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                className="w-5 h-5"
              >
                <path
                  fill-rule="evenodd"
                  d="M9.293 2.293a1 1 0 0 1 1.414 0l7 7A1 1 0 0 1 17 11h-1v6a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-6H3a1 1 0 0 1-.707-1.707l7-7Z"
                  clip-rule="evenodd"
                />
              </svg>
            </span>

            <span className="text text-sm  font-semibold  leading-normal ">
              Home
            </span>
          </Link>
        </li>
        {menus?.map((menu, i) => (
          <li className="px-2">
            <GateKeeper
              permissionCheck={(permission) =>
                permission.module === menu.module && permission.canRead
              }
            >
              <Link
                to={{
                  pathname: menu?.link,
                  // search:
                  //   location?.pathname === menu?.link
                  //     ? location.search
                  //     : `?search=&page=1&pageSize=10`,
                  search:
                    location?.pathname.split("/")[1] === "tasks" &&
                    location?.pathname.split("/")[1] ===
                      menu?.link.split("/")[1]
                      ? location.search
                      : location?.pathname === menu?.link
                      ? location.search
                      : `?search=&page=1&pageSize=10`,
                }}
                state={{ from: location.pathname }}
                key={i}
                onClick={(e) => {
                  setActive(menu.name);
                }}
                className={` sidebar-menu flex items-center text-md gap-2 font-semibold  leading-normal
                                  hover:bg-orange-600 hover:text-white rounded-md
                                  ${
                                    menu?.name === active
                                      ? "text-orange-600"
                                      : "black"
                                  }`}
              >
                <span className="icon ">{menu.icon}</span>
                <span className="text text-sm  font-semibold  leading-normal ">
                  {menu.name}
                </span>
              </Link>
            </GateKeeper>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
